const styles = theme => ({
  form: {
    display: "flex",
    flexDirection: "column",
    color: theme.palette.primary.default
  },
  employerCodeTitle: {
    color: theme.palette.primary.default
  },
  registerExplanation: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Register/components/EmployerCode/styles.js